// src/GroupedBarChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GroupedBarChartSecond = ({ data, barColors }) => {
  // Ensure barColors is defined and has the correct length
  const colors = barColors || [
    'rgba(255, 99, 132, 0.2)', // Default color for Dataset 1
    'rgba(54, 162, 235, 0.2)'  // Default color for Dataset 2
  ];

  // If barColors are provided, make sure they match the number of datasets
  const datasets = data.datasets.map((dataset, index) => ({
    ...dataset,
    backgroundColor: colors[index],
    borderColor: colors[index] ? colors[index].replace('0.2', '1') : 'rgba(0, 0, 0, 1)', // Darker border color
  }));

  const chartData = {
    labels: data.labels || [],
    datasets: datasets,
  };

  const options = {
    responsive : true,
    maintainAspectRatio: false,
    plugins: {
        title: {
            display: false, // Hides the chart title
          },
          datalabels:{
            display: false,
          },
          legend: {       
            display: true, // Show or hide the legend
            position: 'bottom', // Position of the legend
            align: 'center', // Alignment of the legend
            labels: {             
              padding: (0, 15, 0, 10), // Padding around the legend labels
              boxWidth: 7, // Width of the color box in the legend
              boxHeight: 7, // Height of the color box in the legend
              usePointStyle: true, // Use point styles instead of boxes             
            },
            title: {
                display: true,
                padding: -7,
              },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y;
            }
            return label;
          },
        },
      },
    },
    layout:{
        padding: {
            bottom: 0, // Remove extra space below the chart
          },        
    },
    scales: {
      x: {
        padding: 0,
        grid:{
            display: false,
        },
        title: {
            display: false,
            text: 'Month'
        },
        ticks: {
            beginAtZero: true,
            padding: 0, 
            display: true, // Hides the y-axis labels
          },
        stacked: false,
        beginAtZero: true,
      },
      y: {
        grid:{
            display: false,
        },
        ticks: {
            suggestedMax:50,
            suggestedMin:1,
            beginAtZero:true,
            max:100,
            autoSkip:true,
            lineHeight:2,
        },
        stacked: false,
        title: {
          display: true,
          text: 'Response Count',
        },
      },
    },
  };

  return (
      <Bar data={chartData} options={options} />
  );
};

export default GroupedBarChartSecond;
